<template>
    <div class="flex flex-col gap-2 w-full">
      <Select
        v-model="internalSelectedOption"
        :options="options"
        optionLabel="name"
        :overlayStyle="{ direction: 'ltr' }"
        :placeholder="placeholder"
        @change="handleChange"
      >
        <template #option="slotProps">
          <p
            :class="`text-sm ${
              $i18n?.locale === 'ar' ? 'text-right' : 'text-left'
            }`"
          >
            {{ slotProps.option.name }}
          </p>
        </template>
      </Select>
    </div>
  </template>
  
  <script>
  import Select from 'primevue/select';
  
  export default {
    name: 'SimpleReasonSelect',
    components: {
      Select,
    },
    props: {
      // The options for THIS specific dropdown
      options: {
        type: Array,
        required: true,
      },
      // The currently selected option for THIS dropdown (for v-model binding)
      modelValue: {
        type: Object, // The selected option object itself
        default: null,
      },
      placeholder: {
        type: String,
        default: 'Select a reason',
      },
    },
    emits: ['update:modelValue', 'selection-made'],
  
    data() {
      return {
        internalSelectedOption: this.modelValue,
      };
    },
    watch: {
      modelValue(newValue) {
        this.internalSelectedOption = newValue;
      },
      internalSelectedOption(newValue) {
          // Only emit if the internal state changes, to avoid infinite loops
          // when modelValue is updated externally.
          if (newValue !== this.modelValue) {
              this.$emit('update:modelValue', newValue);
          }
      }
    },
    methods: {
      handleChange() {
        // When a selection is made, emit the selected option
        // and also a specific event for the parent to react to.
        this.$emit('selection-made', this.internalSelectedOption);
        // The v-model update is handled by the internalSelectedOption watcher
      },
    },
  };
  </script>